import React, {Component} from 'react'

import styled from "styled-components"
import SelectedSettlementProviderStatus
  from "manager/views/components/Settlement/SelectedProviderStatus/SelectedSettlementProviderStatus"
import SelectNewSettlementProvider
  from "manager/views/components/Settlement/SelectNewProvider/SelectNewSettlementProvider"
import {connect} from "react-redux"
import {createStructuredSelector} from "reselect"
import {selectSelectedSettlementProvider} from "manager/selectors/referral_selectors"


const SettlementProviderContainer = styled.div`
`

/**
 * Component for rendering the appropriate settlement provider cards.
 */
class SettlementProviderSelection extends Component {

  render() {
    const {selectedSettlementProvider} = this.props
    return (
      <SettlementProviderContainer>
        {
          selectedSettlementProvider ? (
            <SelectedSettlementProviderStatus/>
          ) : (
            <SelectNewSettlementProvider/>
          )
        }
      </SettlementProviderContainer>
    )
  }

}

const selector = createStructuredSelector({
  selectedSettlementProvider: selectSelectedSettlementProvider
})

export default connect(selector)(SettlementProviderSelection)
